import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconThumbDownLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.308 15.5c-.476 0-.896-.182-1.26-.547-.366-.365-.548-.785-.548-1.26v-1.616c0-.105.014-.217.04-.338a3.88 3.88 0 0 1 .09-.335L4.498 4.64c.143-.32.383-.59.72-.81a1.9 1.9 0 0 1 1.055-.33h10.515v12l-5.817 5.767a1.208 1.208 0 0 1-.69.356 1.19 1.19 0 0 1-.752-.135 1.181 1.181 0 0 1-.527-.546 1.058 1.058 0 0 1-.071-.733l1.077-4.709h-6.7Zm11.98-.639V5H6.27c-.07 0-.142.02-.216.058a.372.372 0 0 0-.168.192L3 12v1.692a.3.3 0 0 0 .087.222.3.3 0 0 0 .22.086h8.597l-1.254 5.48 4.639-4.619ZM19.693 3.5c.497 0 .923.177 1.277.531.354.354.531.78.531 1.277v8.384c0 .497-.177.923-.531 1.277a1.74 1.74 0 0 1-1.277.531h-2.904V14h2.904a.3.3 0 0 0 .221-.086.3.3 0 0 0 .087-.222V5.308a.3.3 0 0 0-.087-.221.3.3 0 0 0-.22-.087h-2.905V3.5h2.904Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconThumbDownLine;
